import { render, staticRenderFns } from "./pay-xiaoBuDian.vue?vue&type=template&id=bf0f8d04&scoped=true"
import script from "./pay-xiaoBuDian.vue?vue&type=script&lang=js"
export * from "./pay-xiaoBuDian.vue?vue&type=script&lang=js"
import style0 from "./pay-xiaoBuDian.vue?vue&type=style&index=0&id=bf0f8d04&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf0f8d04",
  null
  
)

export default component.exports